// 海外TOP用のjs

// import $ from 'jquery'

// コントローラー
import TopController from './_top'

// require('./bootstrap')

// グローバルオブジェクトとして登録
window.controller = TopController

$(function () {
  console.log('読み込み完了')
  if (TopController) TopController.init()
  if (TopController) TopController.collectObj()
  if (TopController) TopController.hookAll()
  if (TopController) TopController.hookAfterInit()
})
